import React, { Component } from 'react';

class CreatedLink extends Component {
  render() {
    return (
      // TODO: Styles should be moved to css
      <div className="link-itm__col" style={{ position: 'relative' }}>
        <div style={{ position: 'absolute', top: '7px', left: '7px' }}>
          <img
            src={this.props.link.image.thumb.url}
            alt="miniature"
            style={{ borderRadius: '6px', display: 'block' }}
          />
        </div>
        <div className="link-itm__descr" style={{ paddingLeft: '60px' }}>
          <div className="link-itm__text">{this.props.link.image.filename}</div>
        </div>
      </div>
    );
  }
}

export default CreatedLink;



// WEBPACK FOOTER //
// ./src/components/CreatedImageLink/CreatedImageLink.js